import { PURCHASE_EVENT } from "@/core/data";
import exposePurchaseEvent from "@/core/lib/gtm/exposePurchaseEvent";
import { pushVirtualPageView as pushDataDogVirtualPageView } from "@/core/lib/datadog/datadog";
import {
  hasEventBeenTriggered,
  pushEventTriggeredSignal,
} from "@/core/utils/eventsToExpose/eventUtils";
import { EventCallbackData } from "@/core/utils/eventsToExpose/getEventToExposeCallback";

const CASE_CONVERSION_PAGE_TILE: string = "case-conversion";
const PURCHASE_EVENT_SIGNAL: string = "purchaseEventTriggered";

const pushPurchaseEvent = async ({
  definitionName,
  domain,
}: EventCallbackData) => {
  const itemFound: number | undefined = window.dataLayer.filter(
    (item: any) => item.event === PURCHASE_EVENT
  )?.length;
  if (itemFound) return;

  const caseCreated = await hasEventBeenTriggered(PURCHASE_EVENT_SIGNAL);
  if (caseCreated) return;

  exposePurchaseEvent();
  pushDataDogVirtualPageView(
    CASE_CONVERSION_PAGE_TILE,
    definitionName,
    domain ?? ""
  );
  pushEventTriggeredSignal(PURCHASE_EVENT_SIGNAL);
};

export default pushPurchaseEvent;
